import { PACKAGES, US_PATH_PACKAGES } from '../constants/lineOfBusinessConstants';

export const generateNextPathFromLineOfBusiness = (
  selectedTab,
  routerLocation,
  hasVacationPackagesPath
) => {
  const splitPath = routerLocation.pathname.split('/');
  const activeLocale = splitPath[1];
  const { intlink } = routerLocation.query;

  const nextPath = `/${activeLocale.toLowerCase()}/travel/`;
  if (hasVacationPackagesPath && selectedTab === PACKAGES) {
    return { pathname: `${nextPath}${US_PATH_PACKAGES}`, query: { intlink } };
  }
  return { pathname: `${nextPath}${selectedTab}`, query: { intlink } };
};
